export default __webpack_public_path__ + "static/media/Panaz.22eef9ef.jpg";